{
  "clear": "지우기",
  "invalid": "(유효하지 않음)",
  "loading": "로드 중...",
  "noResults": "결과 없음",
  "valid": "(유효)"
}
